// extracted by mini-css-extract-plugin
export default {"icons-container":"Icons_icons-container__12WHk","small":"Icons_small__mmkId"};